import React, { memo, useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { SvgShowMore } from "@routes/IconeSvg";
import { unavailabilityActions } from "@store/actions";

import DateRangePickerDropdown from "@components/dateRange/DropdownDateRange";
import { ListboxSimple } from "@components/tailwindComponents";
import Button from "@components/tailwindComponents/Button";
import ListboxEmploye from "@components/tailwindComponents/ListboxEmploye";
import useUnavalaibility from "@pages/shared/employeFormNew/JobAndSalary/SharedUnavailability/helpers/_functions";

import { getInitPeriodFilterMonthe } from "@helpers/_functions";

function EmployeTabFilter({ setDataFilter }) {
  const { t } = useTranslation("pages.employés.indisponibility");
  const [period, setPeriod] = useState(getInitPeriodFilterMonthe());
  const [employeeSelected, setEmploye] = useState([]);
  const [selectedType, setSelectedType] = useState({});
  const [dateChanged, setDateChanged] = useState(false);
  const [selectedPlace, setSelectedPlace] = useState({});
  const [selectedMainCause, setSelectedMainCause] = useState({});
  const [selectedInjuryNature, setSelectedInjuryNature] = useState({});
  const [selectedBodyLocation, setSelectedBodyLocation] = useState({});
  const [selectedGravity, setSelectedGravity] = useState({});
  const [selectedWastedTime, setSelectedWastedTime] = useState({});
  const [selectedWorkStop, setSelectedWorkStop] = useState({});
  // const [hasAppliedOnce, setHasAppliedOnce] = useState(false);
  const {
    typeUnavailabilityList,
    unavailabilityPlaceList,
    unavailabilityMainCauseList,
    unavailabilityGravityList,
    unavailabilityInjuryNatureList,
    unavailabilityBodyLocationList
  } = useUnavalaibility();
  const [showFilter, setShowFilter] = useState(false);
  const reduxDispatch = useDispatch();
  const employers = useSelector((state) => state.commonData.employers);

  const wastedTimeList = [
    { _id: "1", name: "Oui" },
    { _id: "2", name: "Non" }
  ];

  const workStopList = [
    { _id: "1", name: "Oui" },
    { _id: "2", name: "Non" }
  ];

  useEffect(() => {
    reduxDispatch(unavailabilityActions.loadData);
  }, []);

  useEffect(() => {
    if (!dateChanged) {
      setDateChanged(true);
    }
  }, [period]);
  const handleChangePeriod = (date) => {
    setPeriod(date?.[0]);
  };
  const resetDateFilter = () => {
    setPeriod({
      startDate: null,
      endDate: null
    });
  };
  const toggleFilter = () => {
    setShowFilter(!showFilter);
  };

  // Active filter effect
  useEffect(() => {
    if (
      !selectedType?._id &&
      !selectedPlace?._id &&
      !selectedMainCause?._id &&
      !selectedInjuryNature?._id &&
      !selectedBodyLocation?._id &&
      !selectedGravity?._id &&
      !selectedWastedTime?._id &&
      !selectedWorkStop?._id &&
      !period
    ) {
      setDataFilter(
        {
          period: {
            startDate: new Date("2000-01-01"),
            endDate: new Date("2100-12-31")
          },
          type: undefined,
          employees: [],
          place: undefined,
          mainCause: undefined,
          gravity: undefined,
          injuryNature: undefined,
          bodyLocation: undefined,
          wastedTime: undefined,
          workStop: undefined
        },
        false
      );
    }
  }, [
    selectedType,
    selectedPlace,
    selectedMainCause,
    selectedInjuryNature,
    selectedBodyLocation,
    selectedGravity,
    selectedWastedTime,
    selectedWorkStop,
    period
  ]);

  const onApplyFilter = async () => {
    let nPeriod = period;
    if (!nPeriod?.startDate || !nPeriod?.endDate) {
      nPeriod = getInitPeriodFilterMonthe();
      setPeriod(nPeriod);
    }
    const data = {
      period: nPeriod,
      type: selectedType?.name,
      employees: employeeSelected,
      place: selectedPlace?.name,
      mainCause: selectedMainCause?.name,
      gravity: selectedGravity?.name,
      injuryNature: selectedInjuryNature?.name,
      bodyLocation: selectedBodyLocation?.name,
      wastedTime: !selectedWastedTime?._id
        ? undefined
        : selectedWastedTime?.name === "Oui",
      workStop: !selectedWorkStop?._id
        ? undefined
        : selectedWorkStop?.name === "Oui"
    };
    await setDataFilter(data, dateChanged);
    setDateChanged(false);
    // setHasAppliedOnce(true);
  };
  return (
    <div className="arh-w-full arh-rounded arh-bg-greyColor arh-p-4">
      <div className="arh-grid arh-grid-cols-4 arh-gap-4">
        <ListboxEmploye
          placeholder={t("Employé")}
          name="employe"
          optionList={employers || []}
          selectedValue={employeeSelected}
          setSelectedValue={setEmploye}
          multiple
          showReset={Boolean(employeeSelected?.length)}
          customClass="arh-ml-[0.925rem]"
        />
        <div className="datepicker_modals_parcours">
          <div className="dateRange_green DateRangePicker_customisation DateRangePicker_customisation--green arh-relative">
            <DateRangePickerDropdown
              key="date_range_periode"
              classParent="arhDatePicker"
              idInput="daterange"
              className="input_simple"
              dateSelected={period}
              textInput={t("Période")}
              SaveCloseRange={handleChangePeriod}
              showResetFilter={
                period.startDate && period.endDate ? true : false
              }
              onResetFilter={resetDateFilter}
              classSwitch="c-switch-pill-checked--green--color--to--left"
              classBackground="green"
            />
          </div>
        </div>
        <ListboxSimple
          placeholder={t("Type d'indisponibilité")}
          name="indisponibilityType"
          optionList={
            typeUnavailabilityList?.map((_type) => ({
              _id: _type?._id,
              name: _type?.name
            })) || []
          }
          selectedValue={selectedType}
          setSelectedValue={setSelectedType}
          showReset={!!selectedType?._id}
        />
        {/* <Button
          onClick={onApplyFilter}
        >
          {t("Appliquer")}
        </Button> */}
        <div className="arh-flex arh-items-center arh-gap-4">
          <Button
            onClick={onApplyFilter}
            className="!arh-w-fit arh-grow"
          >
            {t("Appliquer")}
          </Button>
          <Button
            variant="green-outlined"
            onClick={toggleFilter}
            className="!arh-w-fit"
          >
            <SvgShowMore />
          </Button>
        </div>

        <div
          className={`${showFilter ? "arh-grid arh-grid-cols-4 arh-gap-4" : "arh-hidden"} arh-col-span-4`}
        >
          <ListboxSimple
            placeholder={t("Lieu")}
            name="lieu"
            optionList={unavailabilityPlaceList}
            selectedValue={selectedPlace}
            setSelectedValue={setSelectedPlace}
            showReset={Boolean(selectedPlace?._id)}
          />
          <ListboxSimple
            placeholder={t("Cause Principale")}
            name="cause"
            optionList={unavailabilityMainCauseList}
            selectedValue={selectedMainCause}
            setSelectedValue={setSelectedMainCause}
            showReset={Boolean(selectedMainCause?._id)}
          />
          <ListboxSimple
            placeholder={t("Nature de la blessure/Maladie")}
            name="nature"
            optionList={unavailabilityInjuryNatureList}
            selectedValue={selectedInjuryNature}
            setSelectedValue={setSelectedInjuryNature}
            showReset={Boolean(selectedInjuryNature?._id)}
          />
          <ListboxSimple
            placeholder={t("Emplacement sur le corps")}
            name="emplacement"
            optionList={unavailabilityBodyLocationList}
            selectedValue={selectedBodyLocation}
            setSelectedValue={setSelectedBodyLocation}
            showReset={Boolean(selectedBodyLocation?._id)}
          />
          <ListboxSimple
            placeholder={t("Gravité")}
            name="gravité"
            optionList={unavailabilityGravityList}
            selectedValue={selectedGravity}
            setSelectedValue={setSelectedGravity}
            showReset={Boolean(selectedGravity?._id)}
          />
          <ListboxSimple
            placeholder={t("Perte de temps")}
            name="perte"
            optionList={wastedTimeList}
            selectedValue={selectedWastedTime}
            setSelectedValue={setSelectedWastedTime}
            showReset={Boolean(selectedWastedTime?._id)}
          />
          <ListboxSimple
            placeholder={t("Arrêt de travail")}
            name="Arrêt"
            optionList={workStopList}
            selectedValue={selectedWorkStop}
            setSelectedValue={setSelectedWorkStop}
            showReset={Boolean(selectedWorkStop?._id)}
          />
        </div>
      </div>
    </div>
  );
}

export default memo(EmployeTabFilter);
